import { SearchResultItem } from '@xiag-search/sdk';
import { SearchResultDesignVariant } from 'src/state/SearchResult';

export function getItemDesignVariant(searchItem: SearchResultItem): SearchResultDesignVariant | null {
    const designVariant = searchItem.customFields['design-variant'];
    switch (designVariant) {
        case '1':
        case '2':
            return designVariant;

        default:
            return null;
    }
}
